import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@environments/environment";
import { AuthService } from "@lib/auth/interfaces/IAuthService";
import Keycloak from "keycloak-js";
import { UserRolesService } from "@lib/core/services/user-roles.service";
import { of, tap } from "rxjs";

export const LoggedGuard = () => {
    const keycloakService = inject(Keycloak);
    const authService = inject(AuthService);
    const router = inject(Router);

    const isLogged = authService.isLoggedIn();
    if (!isLogged) {
        keycloakService.login({
            redirectUri: environment.keycloak.redirectUrl + router.url,
        }).catch(e => console.error(e));
    }
    return isLogged;
};
export const AdminGuard = () => {
    const keycloakService = inject(Keycloak);
    const authService = inject(AuthService);
    const router = inject(Router);
    const roleService = inject(UserRolesService);

    const isLogged = authService.isLoggedIn();

    if (!isLogged) {
        keycloakService.login({
            redirectUri: environment.keycloak.redirectUrl + router.url,
        }).catch(e => console.error(e));
        return of(false);
    }

    return roleService.isAdmin().pipe(
        tap(isAdmin => console.log("admin:", isAdmin)),
    );
};
